import { render, staticRenderFns } from "./marketplaceScm.vue?vue&type=template&id=441e32ed&scoped=true"
import script from "./marketplaceScm.vue?vue&type=script&lang=js"
export * from "./marketplaceScm.vue?vue&type=script&lang=js"
import style0 from "./marketplaceScm.vue?vue&type=style&index=0&id=441e32ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441e32ed",
  null
  
)

export default component.exports